import { TemplateModel } from '../models/template.model';
import { BaseSevice } from './BaseService';

class SupportService extends BaseSevice {
  apiUrl = 'api/support';

  sendMessage(name: string, email: string, message: string) {
    if (!name) throw new Error('Name should not be empty');
    if (!email) throw new Error('Email should not be empty');
    if (!message) throw new Error('Message should not be empty');

    return this.request<TemplateModel>(`${this.apiUrl}`, 'post', undefined, {
      name,
      email,
      message,
    });
  }
}

export const supportService = new SupportService();
